/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.10.5",
    versionName: "0.2.0-nightly.2025.10.5",
    versionChannel: "nightly",
    buildDate: "2025-10-05T00:08:08.329Z",
    commitHash: "c756c3871f0fe17e1cafeedce16048d0a122bb1b",
};
